/* ============================================
   Free Shipping Bar – Auto Currency + Smooth Animation
   ============================================ */

(function () {

  // Basis-Schwelle in EUR
  const BASE_GOAL_EUR = 70;

  // Ermittelt den dynamischen Schwellenwert in der aktiven Währung
  function getShippingGoal() {
    var currencyData = (window.Shopify && Shopify.currency) ? Shopify.currency : null;
    var currency = currencyData && currencyData.active ? currencyData.active : "EUR";
    var rate = currencyData && currencyData.rate ? currencyData.rate : 1;

    // Beispiel:
    // currency = "HUF"
    // rate = 390 (1 EUR = 390 HUF)
    // 70 * 390 = 27300 HUF
    var goalInCurrency = BASE_GOAL_EUR * rate;
    return goalInCurrency;
  }

  function formatAmount(value) {
    var r = Math.round(value * 100) / 100;
    return Number.isInteger(r) ? r.toString() : r.toFixed(2);
  }

  function getLang() {
    var lang = (document.documentElement.lang || "").toLowerCase();
    return lang.startsWith("de") ? "de" : "en";
  }

  function updateFreeShippingBar() {
    var bar = document.getElementById("free-shipping-bar");
    if (!bar) return;

    var progress = bar.querySelector(".shipping-progress-fill");
    var title = bar.querySelector(".shipping-title");
    var text = bar.querySelector(".shipping-remaining");

    var total = parseFloat(bar.getAttribute("data-cart-total"));
    if (isNaN(total)) total = 0;

    var GOAL = getShippingGoal();
    var percent = Math.min((total / GOAL) * 100, 100);
    var remaining = Math.max(0, GOAL - total);
    var lang = getLang();

    // Balken immer zeigen
    bar.classList.remove("hidden");

    // Titel – zeigt immer die Basis-Schwelle in EUR
    if (title) {
      title.textContent =
        lang === "de"
          ? "Kostenloser Versand ab " + BASE_GOAL_EUR + " €"
          : "Free shipping over €" + BASE_GOAL_EUR;
    }

    // Text unten
    if (text) {
      if (remaining > 0.01) {
        var formatted = formatAmount(remaining);
        text.innerHTML =
          lang === "de"
            ? "Noch <span class='bold'>" + formatted + "</span> bis zum Gratisversand"
            : "<span class='bold'>" + formatted + "</span> left for free shipping";
      } else {
        text.innerHTML =
          lang === "de"
            ? "<span class='bold'>Kostenloser Versand erreicht!</span>"
            : "<span class='bold'>Free shipping reached!</span>";
      }
    }

    // Fortschrittsbalken – SMOOTH ANIMATION
    if (progress) {
      // vorheriger Prozentwert aus data-Attribut
      var prevPercent = parseFloat(progress.getAttribute("data-percent"));

      if (isNaN(prevPercent)) {
        // Erstes Mal: von 0% smooth auf Ziel
        progress.style.width = "0%";

        requestAnimationFrame(function () {
          progress.style.width = percent + "%";
        });
      } else {
        // weitere Updates: von alter Breite → neue Breite (CSS transition macht den Rest)
        progress.style.width = percent + "%";
      }

      // neuen Wert merken, damit wir nicht jedes Mal wieder von 0 starten
      progress.setAttribute("data-percent", percent);
    }
  }

  // Debounce
  var timer = null;
  function scheduleUpdate() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(updateFreeShippingBar, 50);
  }

  // Beim Laden
  document.addEventListener("DOMContentLoaded", scheduleUpdate);

  // Shopify / Theme Events
  document.addEventListener("cart:updated", scheduleUpdate);
  document.addEventListener("cart:change", scheduleUpdate);
  document.addEventListener("shopify:section:load", scheduleUpdate);

})();
